import { render, staticRenderFns } from "./EMailLabel.vue?vue&type=template&id=fe26571c&"
import script from "./EMailLabel.vue?vue&type=script&lang=ts&"
export * from "./EMailLabel.vue?vue&type=script&lang=ts&"
import style0 from "./EMailLabel.vue?vue&type=style&index=0&id=fe26571c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports